import React, {Component} from 'react';
import {
  Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, TextField,
} from '@mui/material';
import Api from '../../api';
import {EDIT_SENDER_ID_DLT_TMD_URL} from '../../lib/constant';
import DltTmdField from '../../components/DltTmdField';

// Per-header downstream DLT Telemarketer ID (TM-D) + TMD mode.
// Mode decides the TMD part of TLV 0x1402 = PEID,TMA[,TMD]:
//   direct   — no TMD, chain ends with ComBird (the default / end-state)
//   explicit — this header's own TMD (approved via a specific downstream)
//   inherit  — the route operator's TM ID for the message's sms type
//              (tenant route in Manage Operators, else the global route)
const MODE_HELP = {
  direct:
    'Chain ends with ComBird (PEID,TMA). Use when this header is approved directly under ComBird\'s TM registration.',
  explicit:
    'Use the downstream TMD recorded below. CSV for multi-hop.',
  inherit:
    'Use the TM ID of the operator this tenant\'s traffic routes through for the message\'s SMS type (tenant route in Manage Operators, else the global route).',
};

export default class EditSenderIdTmd extends Component {
  constructor(props){
    super(props);
    this.state={
      val : props.dltTmdId || '',
      mode: props.dltTmdMode || (props.dltTmdId ? 'explicit' : 'direct'),
      error: '',
      saving: false
    }
  }

  handleSave = async () =>{
    const {mode} = this.state;
    const trimmed = mode === 'explicit' ? this.state.val.trim() : '';
    if (mode === 'explicit' && !trimmed) {
      this.setState({error: 'Own TMD mode requires a TMD value'});
      return;
    }
    this.setState({error: '', saving: true});
    try {
      let url = EDIT_SENDER_ID_DLT_TMD_URL.replace('{instId}', this.props.tenantId);
      url = url.replace('{senderid}', this.props.senderId);
      await Api.put(url, {dlt_tmd_id: trimmed, dlt_tmd_mode: mode});
      this.props.onSuccess();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data?.error || err?.message || 'Failed to update downstream TMD';
      this.setState({error: msg, saving: false});
    }
  }

  render(){
    const {val, mode, error, saving} = this.state;
    return(
      <Dialog
        open={true}
        onClose={this.props.onClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Downstream TMD</DialogTitle>
        <DialogContent style={{paddingTop: 16}}>
          <TextField
            label="Header"
            value={this.props.senderId}
            fullWidth
            variant="standard"
            InputProps={{readOnly: true}}
            style={{marginBottom: 16}} />
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              value={mode}
              onChange={(e)=>{this.setState({mode: e.target.value, error: ''})}}
            >
              <FormControlLabel value="direct" control={<Radio size="small" />} label="Direct — ComBird is the TMD (default)" />
              <FormControlLabel value="explicit" control={<Radio size="small" />} label="This header's own TMD" />
              <FormControlLabel value="inherit" control={<Radio size="small" />} label="Inherit from route operator" />
            </RadioGroup>
            <FormHelperText sx={{mx: 0}}>{MODE_HELP[mode]}</FormHelperText>
          </FormControl>
          {mode === 'explicit' && (
            <DltTmdField
              label="Downstream TMD (DLT)"
              value={val}
              onChange={(v)=>{this.setState({val : v, error: ''})}}
              helperText={error || "Downstream DLT Telemarketer ID this header's chain is approved via. CSV for multi-hop."}
              textFieldProps={{fullWidth: true, variant: 'standard', error: !!error}}
            />
          )}
          {mode !== 'explicit' && error ? (
            <FormHelperText error sx={{mx: 0}}>{error}</FormHelperText>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} disabled={saving}>Cancel</Button>
          <Button onClick={this.handleSave} variant='contained' disabled={saving}>
            {saving ? <CircularProgress size={20} /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}
